export interface ProductMeta {
  awards: Award[];
  ranking: Ranking[];
  taxonomies: Taxonomies;
  productLearnMoreImageUrls: string[];
  consciousChoices: ConsciousChoice[];
  ingredientBenefits: IngredientBenefit[];
  productUsageInstruction: string;
}

export interface Award {
  termId: number;
  name: string;
  slug: string;
  awardTitle: string;
}

export interface Ranking {
  termId: number;
  name: string;
  slug: string;
  productRank: number;
}

export interface Taxonomies {
  skinType: SkinType[];
  skinConcern: SkinConcern[];
  efficacy: Efficacy[];
  starIngredient: StarIngredient[];
  sensitiveIngredient: SensitiveIngredient[];
}

export interface SkinType {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface SkinConcern {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface Efficacy {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface StarIngredient {
  termId: number;
  name: string;
  slug: string;
  impact: string;
  description: string;
  ewgRate: number;
}

export interface SensitiveIngredient {
  termId: number;
  name: string;
  slug: string;
  impact: string;
  description: string;
  ewgRate: number;
}

export interface ConsciousChoice {
  id: number;
  title: string;
  description: string;
}

export interface IngredientBenefit {
  benefit: Benefit;
  ingredients: Ingredient[];
}

export interface Benefit {
  termId: number;
  name: string;
  slug: string;
  description: string;
}

export interface Ingredient {
  termId: number;
  name: string;
  slug: string;
  impact: string;
  description: string;
  ewgRate: number;
}
